import { render } from "react-dom";
import Groups from "./groups";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Header from "../layout/header";
import Card from "@mui/material/Card";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState, useEffect, Fragment } from "react";
import { Autocomplete, Box, Button, FormControl, IconButton, LinearProgress, TextField, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store/store";
import AddNewNodeModal from "./addEditModal";
import DeleteCategoryModal from "./deleteCategoryModal";

import {
  getCategoryList,
  addNewMasterCategory,
  deleteCategoryThunk,
} from "../../store/thunk/categorySubstanceThunk";
import { getTenantDropDownList } from "../../store/thunk/tenantThunk";
import CustomHeader from "../pageHeader/Index";
import { setTenantId } from "../../store/thunk/commonThunk";
import MUIDataTable from "mui-datatables";
import { HtmlTooltip } from "../../constants";
import { defaultCategoryDisabled } from "../../constants";

export default function GroupsSubstance() {
  const dispatch = useAppDispatch();
  const [tenant, setTenant] = useState<any>(null);
  const [show, setShow] = useState(false);
  const [list, setList] = useState([]);
  const [count, setCount] = useState("0");
  const { userData } = useAppSelector((state: any) => state.authReducer);
  const { categoryList, categoryLoading } = useAppSelector(
    (state) => state.categorySubstanceSlice);
  const { tenantDropDownList } = useAppSelector((state) => state.tenantSlice);
  const [addModal, setAddModal] = useState(false);
  const [addSubstanceModal, setAddSubstanceModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const items = JSON.parse(localStorage.getItem("tenantId") || "{}");

  useEffect(() => {
    if (userData.group == "admin") {
      setShow(true);
    }
    let obj: any = {
      name: userData.name,
      tenantCode: userData.tenantCode,
      tenantId: userData.tenantId,
    };
    if (userData.tenantId) {
      setTenant(obj);
      dispatch(getCategoryList({ request: { tenantCode: userData.tenantCode } }));
    }
  }, [userData]);

  useEffect(() => {
    const tenant_info = JSON.parse(userData?.tenant_info || "{}");
    if (tenant_info?.tenantCode) {
      setTenant({
        tenantCode: tenant_info?.tenantCode,
        tenant_name: tenant_info?.tenant_name,
        tenantId: tenant_info?.tenantId,
      });
    } else if (userData?.tenantCode) {
      setTenant({
        tenantCode: userData?.tenantCode,
        tenant_name: userData?.tenant_name,
        tenantId: userData?.tenantId,
      });
    }
  }, [JSON.stringify({ location: userData?.location_info, tenantCode: userData?.tenantCode, tenantId: userData?.tenantId })]);

  useEffect(() => {
    const tenantCode = tenant?.tenantCode
    if (tenantCode) {
      dispatch(getCategoryList({ request: { tenantCode: tenantCode } }));
    }
  }, [JSON.stringify(tenant)]);
  const defaultProps = {
    options: tenantDropDownList?.getTenants
      ? [
        ...tenantDropDownList?.getTenants.tenants,
        {
          tenantCode: "default",
          tenantId: "0000",
          tenant_name: "Default",
        },
      ] : [],
    getOptionLabel: (option: any) => option.tenant_name,
  };

  useEffect(() => {
    // dispatch(getCategoryList({}));
    dispatch(getTenantDropDownList({}));
  }, []);


  useEffect(() => {
    let categores: any = [];
    if (categoryList && categoryList.length > 0) {
      categoryList.map((row: any, index: any) => {
        categores.push([
          row.pk,
          row.category_name,
          row.order_number,
          row
        ]);
        return row;
      });
      setCount(categoryList.length);
    }
    setList(categores);
  }, [categoryList]);

  const handleChangeTenant = (event: any, value: any) => {
    let request = {
      tenantId: value.tenantCode,
    };
    if (value.tenantCode !== "default") {
      dispatch(setTenantId(value));
    }
    setTenant(value);
    dispatch(getCategoryList({ request: { tenantCode: value.tenantCode } }));
  };

  const handleOpenModal = (data: any) => {
    setModalData(data || {});
    setAddModal(true);
  };
  const handleOpenDeleteModal = (data: any) => {
    setAddSubstanceModal(true);
    setModalData(data || {});
  };
  const closeModal = () => {
    setAddModal(false);
    setModalData({});

  };

  const closeModalSubstance = () => {
    setAddSubstanceModal(false);
    setModalData({});
  };

  const updateCategory = (data: any) => {
    let request: any = {
      tenantCode: items && items.tenantId ? items.tenantCode : userData.tenantCode,
      category_name: data.category_name,
      order_number: data.order_number || 0,
    };
    if (data.pk !== undefined && data.sk !== undefined) {
      request = {
        tenantCode: items && items.tenantId ? items.tenantCode : userData.tenantCode,
        category_name: data.category_name,
        order_number: data.order_number || 0,
        pk: data.pk,
        sk: data.sk,
      };
    }
    dispatch(addNewMasterCategory({ request: request })).then(() => {
      closeModal();
    });
  };

  const deleteCategory = (data: any) => {
    dispatch(deleteCategoryThunk({ request: { pk: data.pk, sk: data.sk }, callback: closeModalSubstance }));
  };

  const columns = [
    {
      name: "Tenant Code",
      options: {
        filter: true,
      },
    },
    {
      name: "Category Name",
      options: {
        filter: true,
      },
    },
    {
      name: "Category Order",
      options: {
        filter: true,
      },
    },
    {
      name: "Action",
      options: {
        filter: false,
        customBodyRender: (value: any) => {
          return (
            <Box sx={{ display: "flex !important" }}>
              {(value.pk !== "default" || !defaultCategoryDisabled.includes(value.sk)) && (
                <>
                  <HtmlTooltip
                    title={
                      <Fragment>
                        <Typography color="inherit">
                          Edit Category
                        </Typography>
                      </Fragment>
                    }
                    placement="bottom"
                  >
                    <IconButton
                      aria-label="edit"
                      onClick={() => handleOpenModal(value)}
                    >
                      <EditIcon className="edit-icon" />
                    </IconButton>
                  </HtmlTooltip>

                  <HtmlTooltip
                    title={
                      <Fragment>
                        <Typography color="inherit">
                          Delete Category
                        </Typography>
                      </Fragment>
                    }
                    placement="bottom"
                  >
                    <IconButton
                      aria-label="delete"
                      onClick={() => handleOpenDeleteModal(value)}
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  </HtmlTooltip>
                </>)
              }
            </Box>
          );
        },
      },
    },
  ]
  const options: any = {
    sort: true,
    filter: false,
    print: false,
    download: false,
    viewColumns: false,
    responsive: "scroll",
    selectableRows: false,
    rowsPerPageOptions: [5, 10, 20, 50],
  };

  return (
    <div>
      <CustomHeader title="Category Management">
        <FormControl margin="normal" sx={{ width: "200px" }}>
          <Button
            disabled={tenant ? false : true}
            variant="contained"
            color="primary"
            sx={{ mr: 2 }}
            onClick={() => handleOpenModal({})}
          >
            Add Category
          </Button>
        </FormControl>
        {show && (
          <FormControl margin="normal" sx={{ width: "240px" }}>
            <Autocomplete
              {...defaultProps}
              id="demo-simple-select"
              onChange={handleChangeTenant}
              renderTags={() => null}
              value={tenant}
              renderInput={(params) => (
                <TextField {...params} label="Select Tenant" className="custom-input" />
              )}
            />
          </FormControl>
        )}
      </CustomHeader>
      <Card sx={{ m: 3 }}>
        {categoryLoading && <LinearProgress color="secondary" />}
        <MUIDataTable
          title={"Category List"}
          data={list}
          columns={columns}
          options={options}
        />
      </Card>
      {addModal && (
        <AddNewNodeModal
          open={addModal}
          handleClose={closeModal}
          modalData={modalData}
          updateCategory={updateCategory}
          categoryList={categoryList}
          categoryLoading={categoryLoading}
        />
      )}

      {addSubstanceModal && (
        <DeleteCategoryModal
          open={addSubstanceModal}
          handleClose={closeModalSubstance}
          modalData={modalData}
          categoryLoading={categoryLoading}
          deleteCategory={deleteCategory}
        />
      )}
    </div>
  );
}
